import { EForceOpenOrder } from "@features/resources/services/types/enum";
import { ResourceEntity } from "@features/resources/services/types/resourceEntity";
import { generateCId } from "@lib/utils/randomUUID";
import { EPreSelectedResource } from "./enums/preSelectedResourceEnum";
import { CheckSuitableForMovingOrderEnum } from "../../lib/order/types/Enums";

export interface IMovingOrder {
  movingOrderType?: CheckSuitableForMovingOrderEnum;
  itemAvailable? : boolean
}

export class PreSelectedResourceInfo {
  id: string;
  type: EPreSelectedResource | null;
  resources: ResourceEntity[];
  resourcesAlternative?: ResourceEntity[] | null[] | null;
  message?: string | null;
  forceOpenOrder?: EForceOpenOrder | null;
  isResourcePending?: boolean | null;
  movingOrder?: IMovingOrder;

  constructor(data?: Partial<PreSelectedResourceInfo>) {
    this.id = data?.id ?? generateCId();
    this.type = data?.type ?? null;
    this.resources = data?.resources ?? [];
    this.resourcesAlternative = data?.resourcesAlternative ?? null;
    this.message = data?.message ?? null;
    this.forceOpenOrder = data?.forceOpenOrder ?? null;
    this.isResourcePending = data?.isResourcePending ?? null;
    this.movingOrder = data?.movingOrder;
  }
}
